'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useToolbarDividerBase_unstable: function() {
        return useToolbarDividerBase_unstable;
    },
    useToolbarDivider_unstable: function() {
        return useToolbarDivider_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdivider = require("@fluentui/react-divider");
const _ToolbarContext = require("../Toolbar/ToolbarContext");
const useToolbarDivider_unstable = (props, ref)=>{
    const state = useToolbarDividerBase_unstable(props, ref);
    return {
        ...state,
        appearance: 'default'
    };
};
const useToolbarDividerBase_unstable = (props, ref)=>{
    const vertical = (0, _ToolbarContext.useToolbarContext_unstable)((ctx)=>ctx.vertical);
    return (0, _reactdivider.useDivider_unstable)({
        vertical: !vertical,
        ...props
    }, ref);
};
